import { BooleanInput, coerceBooleanProperty, coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
export const symbolPath = '/assets/ui-kit/symbol-defs.svg';

/**
 * UIKit design icon.
 * @deprecated Use FormaIcon from Forma instead, which should be used for all new development. UIKitIcon should only be used for legacy support until all icons are migrated to FormaIcon, at which point UIKitIcon can be removed.
 */
@Component({
    selector: 'uikit-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UIKitIcon {
  symbolPath = symbolPath;
  @Input() icon: string;

  /* Size in px */
  @HostBinding('style.width.px')
  @HostBinding('style.height.px')
  _size: number;
  @Input()
  set size(value: NumberInput) {
    this._size = coerceNumberProperty(value);
  }

  @HostBinding('class.block') public _block = false;

  @Input()
  get block(): boolean {
    return this._block;
  }
  set block(value: BooleanInput) {
    this._block = coerceBooleanProperty(value)
  }
}
